// Node Modules
import { RichText } from 'prismic-reactjs';

// Components
import OurLocations from '@/components/home/our-locations/OurLocations';
import Container from '@/components/global-components/Container';
import DesktopPhotoContainer from '@/components/global-components/photos/DesktopPhotoContainer';
import MobilePhotoContainer from '@/components/global-components/photos/MobilePhotoContainer';
import GroupTours from './group-tours/GroupTours';

// Themes
import theme from '@/themes/index';

const ToursBody = ({
  content: {
    title,
    images,
    description,
    toursPerLocation,
    cpiGroups,
    whyCpiGroups,
    ourLocations,
  },
  isDesktop,
  isMobile,
}) => {
  return (
    <>
      <section className='header'>
        <h3>{title}</h3>
      </section>
      <section className='photos'>
        <Container>
          {!isDesktop ? (
            <MobilePhotoContainer
              images={images}
              isDesktop={isDesktop}
            />
          ) : (
            <DesktopPhotoContainer
              images={images}
              buttonTexts='See all photos'
              isDesktop={isDesktop}
            />
          )}
        </Container>
      </section>
      <section className='description'>
        <Container>
          <div className='description-container'>
            <RichText render={description} />
          </div>
          <section className='our-locations'>
            <OurLocations
              isMobile={isMobile}
              isDesktop={isDesktop}
              content={ourLocations}
            />
          </section>
        </Container>
      </section>
      
      <style jsx>{`
        hr {
          width: 100%;
          max-width: 87.5rem;
          margin: 0 auto;
        }

        section.header {
          padding: 8rem 0 2rem;
          text-align: center;
        }

        section.photos,
        section.description,
        section.dele-exam,
        section.cpi-groups {
          padding: 2rem 2rem;
        }

        section.header h3 {
          margin-block-start: 0;
          margin-block-end: 0;
        }

        section.description {
          text-align: center;
          padding-bottom: 2rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.photos,
          section.header,
          section.description,
          section.dele-exam,
          section.cpi-groups {
            padding: 3rem 4.5rem;
          }

          section.description {
            text-align: left;
          }
        }
      `}</style>
      <style global jsx>{`

        section.description .tours-location p {
          color: ${theme.fontColors.optional4};
        }

        section.description .tours-location a {
          color: ${theme.fontColors.optional4};
        }
     `}</style>
    </>
  );
};

export default ToursBody;
